import { Check } from '@mui/icons-material';
import useAddRequestStore from 'store/addRequestStore';
import { classNames } from 'util/Funcs';
import AdditionalPreferences from './AdditionalPreferences';
import AddRequestFooterButtons from './AddRequestFooterButtons';
import BudgetTimeline from './BudgetTimeline';
import ContactInformation from './ContactInformation';
import FinalPreview from './FinalPreview';
import LocationDetails from './LocationDetails';
import PropertyDetails from './PropertyDetails';
import RequestOverview from './request-overview/RequestOverview';

const tabContentMap: Record<string, JSX.Element> = {
    'Request Overview': <RequestOverview />,
    'Location Details': <LocationDetails />,
    'Property Details': <PropertyDetails />,
    'Budget & Timeline': <BudgetTimeline />,
    'Additional Preferences': <AdditionalPreferences />,
    'Contact Information': <ContactInformation />,
    'Final Preview': <FinalPreview />,
};

export default function AddRequestSidebar() {
    const { currentTabIndex, steps } = useAddRequestStore();
    const renderContent = () => tabContentMap[steps[currentTabIndex].name];
    return (
        <>
            <div className="h-screen default-lg:flex hidden">
                <nav aria-label="Progress" className="lg:w-[22%] w-[30%] lg:pl-12 pl-8  pt-16">
                    <ol role="list" className="overflow-hidden">
                        {steps.map((step, stepIdx) => (
                            <li key={step.name} className={classNames(stepIdx !== steps.length - 1 ? 'pb-10' : '', 'relative')}>
                                {step.status === 'complete' ? (
                                    <>
                                        {stepIdx !== steps.length - 1 ? (
                                            <div aria-hidden="true" className="absolute left-3 lg:left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-my-blue" />
                                        ) : null}
                                        <div className="group relative flex items-start">
                                            <span className="flex h-9 items-center">
                                                <span className="relative flex size-7 lg:size-8 items-center justify-center rounded-full bg-my-blue">
                                                    <Check aria-hidden="true" className="size-5 text-white" />
                                                </span>
                                            </span>
                                            <span className="ml-4 flex min-w-0 flex-col">
                                                <span className="text-base font-normal text-light-black/80 font-poppins mt-1.5 text-nowrap leading-6">
                                                    {step.name}
                                                </span>
                                            </span>
                                        </div>
                                    </>
                                ) : step.status === 'current' ? (
                                    <>
                                        {stepIdx !== steps.length - 1 ? (
                                            <div aria-hidden="true" className="absolute left-3 lg:left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300" />
                                        ) : null}
                                        <div aria-current="step" className="group relative flex items-start">
                                            <span aria-hidden="true" className="flex h-9 items-center">
                                                <span className="relative flex size-7 lg:size-8 items-center justify-center rounded-full  bg-my-blue">
                                                    <span className="size-2.5 rounded-full bg-white" />
                                                </span>
                                            </span>
                                            <span className="ml-4 flex min-w-0 flex-col">
                                                <span className="text-base font-normal text-light-black/80 font-poppins mt-1.5 text-nowrap leading-6">
                                                    {step.name}
                                                </span>
                                            </span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {stepIdx !== steps.length - 1 ? (
                                            <div aria-hidden="true" className="absolute left-3 lg:left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300" />
                                        ) : null}
                                        <div className="group relative flex items-start">
                                            <span aria-hidden="true" className="flex h-9 items-center">
                                                <span className="relative flex size-7 lg:size-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white ">
                                                    <span className="size-2.5 rounded-full bg-transparent " />
                                                </span>
                                            </span>
                                            <span className="ml-4 flex min-w-0 flex-col">
                                                <span className="text-base font-normal text-light-black/80 font-poppins mt-1.5 text-nowrap leading-6">
                                                    {step.name}
                                                </span>
                                            </span>
                                        </div>
                                    </>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>
                <div className="flex-1 flex flex-col">
                    <div className="flex-1 overflow-y-auto bg-white pt-10 px-6 pb-24">{renderContent()}</div>
                    <div className="sticky bottom-0 bg-white p-4 shadow-md border-t border-my-gray h-20 ">
                        <AddRequestFooterButtons showPreviosButton={currentTabIndex !== 0} />
                    </div>
                </div>
            </div>
            {/* Mobile Layout */}
            <div className="h-screen flex flex-col default-lg:hidden">
                <nav aria-label="Progress" className="px-4 pt-6 py-8 bg-my-gray/10">
                    <ol role="list" className="flex items-center">
                        {steps.map((step, stepIdx) => (
                            <li key={step.name} className="relative flex-1">
                                {stepIdx !== steps.length - 1 && (
                                    <div
                                        className={classNames('absolute top-4 h-0.5', step.status === 'complete' ? 'bg-my-blue' : 'bg-my-gray')}
                                        style={{
                                            right: '-50%',
                                            left: '50%',
                                        }}
                                        aria-hidden="true"
                                    />
                                )}

                                <div className="relative flex flex-col items-center">
                                    <div className="h-8 flex items-center justify-center">
                                        {step.status === 'complete' ? (
                                            <span className="relative z-10 flex size-8 items-center justify-center rounded-full bg-my-blue">
                                                <Check className="size-5 text-white" aria-hidden="true" />
                                            </span>
                                        ) : step.status === 'current' ? (
                                            <span className="relative z-10 flex size-8 items-center justify-center rounded-full bg-my-blue">
                                                <span className="size-2.5 rounded-full bg-white" />
                                            </span>
                                        ) : (
                                            <span className="relative z-10 flex size-8 items-center justify-center rounded-full border-2 border-my-gray bg-white">
                                                <span className="size-2.5 rounded-full bg-transparent" />
                                            </span>
                                        )}
                                    </div>

                                    {step.status === 'current' && (
                                        <div className={`absolute -bottom-6 left-1/2 -translate-x-1/2 text-center ${stepIdx === 0 ? 'pl-10' : 'pl-0'}`}>
                                            <span className="text-xs font-medium text-light-black/80 whitespace-nowrap px-2">{step.name}</span>
                                        </div>
                                    )}
                                </div>
                            </li>
                        ))}
                    </ol>
                </nav>

                <div className="flex-1 flex flex-col overflow-y-auto">
                    <div className="flex-1 overflow-y-auto bg-white pt-6 px-6 pb-44">{renderContent()}</div>
                </div>

                <div className="absolute bottom-0 left-0 right-0 border-t border-my-gray h-20 bg-white">
                    <AddRequestFooterButtons showPreviosButton={currentTabIndex !== 0} />
                </div>
            </div>
        </>
    );
}
